import { gql } from '@apollo/client'

const AddTrackFromYouTube = gql`
    mutation AddTrackFromYouTube($videoId: ID!) {
        addTrackFromYouTube(videoId: $videoId) {
            alreadyExisted
            track {
                id
                title
                artist
                album
                coverArt {
                    thumb250
                }
                youtubeId
            }
        }
    }
`

export default AddTrackFromYouTube

